import React from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import { ContactForm } from '../forms'

import Contact from '../../../static/img/contact.jpeg'

const ContactPageTemplate = (props) => {
  const { title, meta_title, meta_description } = props

  return (
    <div>
      <Helmet>
        <title>{meta_title}</title>
        <meta name='description' content={meta_description} />
      </Helmet>
      <section
        className='hero is-fullheight is-family-secondary' style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7)), url(${Contact})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',

        }}>
        <div className='hero-body'>
          <div className='container'>
            <br />
            <br />
            <h1 className='title has-text-white is-family-secondary'>
              CONTACT <br /><br /><br />For questions, suggestions or collaborations
            </h1>
            <h2 className='subtitle has-text-white is-family-secondary'>
              send a message, we are always cooking!            </h2>
          </div>
        </div>
      </section>
      <section className='section'>
        <div className='container'>
          <ContactForm />
        </div>
      </section>
    </div>
  )
}

ContactPageTemplate.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  meta_title: PropTypes.string,
  meta_description: PropTypes.string,
}

export default ContactPageTemplate
